import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output
  } from '@angular/core';
  import { MatSelect } from '@angular/material/select';
  import { EMPTY, fromEvent, Subject } from 'rxjs';
  import { delay, filter, switchMap, takeUntil, throttleTime } from 'rxjs/operators';
  
  @Directive({
    selector: '[appMatSelectScrollBottom]',
    standalone: false
})
  export class MatSelectScrollBottomDirective implements OnDestroy {
    private readonly BOTTOM_SCROLL_OFFSET = 25;
    @Output('appMatSelectScrollBottom') reachedBottom = new EventEmitter<void>();
    onPanelScrollEvent = event => {};
    unsubscribeAll = new Subject<boolean>();
  
    constructor(private matSelect: MatSelect) {
      this.matSelect.openedChange
        .pipe(
          filter(isOpened => !!isOpened),
          // Material 21 emits openedChange(true) before the panel ViewChild is set;
          // wait a tick and guard so a fast open/close doesn't crash on undefined panel
          delay(0),
          switchMap(isOpened => {
            const panelEl = this.matSelect.panel?.nativeElement;
            return panelEl
              ? fromEvent(panelEl, 'scroll').pipe(throttleTime(50))
              : EMPTY;
          }),
          takeUntil(this.unsubscribeAll)
        )
        .subscribe((event: any) => {
          if (
            event.target.scrollTop >=
            event.target.scrollHeight -
              event.target.offsetHeight -
              this.BOTTOM_SCROLL_OFFSET
          ) {
            this.reachedBottom.emit();
          }
        });
    }
    ngOnDestroy(): void {
      this.unsubscribeAll.next(true);
      this.unsubscribeAll.complete();
    }
  }
  